import { render, staticRenderFns } from "./PdfPreviewModal.vue?vue&type=template&id=5088ac45&scoped=true&"
import script from "./PdfPreviewModal.vue?vue&type=script&lang=js&"
export * from "./PdfPreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5088ac45",
  null
  
)

export default component.exports